
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  links: [],
  isLoading: false,
  error: null,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
